import { messages as portugueseMessages } from "./pt";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as arabicMessages } from "./ar";

const messages = {
  ...portugueseMessages,
  ...englishMessages,
  ...spanishMessages,
  ...arabicMessages,
};

export { messages };
